var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" Dane zostały wyczyszczone ")]),_c('v-btn',{attrs:{"elevation":"2","color":"primary","to":"/"}},[_vm._v(" Powrót na stronę główną ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }